import React from 'react';

import UniqueId from '../../../services/uid/UniqueId';

import FormDialogContainer from './FormDialogContainer';

interface Props {
  ids: UniqueId[];
}

const ActiveForms = ({ ids }: Props): React.JSX.Element => (
  <>
    {ids.map(id => (
      <FormDialogContainer key={id} open={true} id={id} />
    ))}
  </>
);

export default ActiveForms;
